<template lang="pug">
v-sheet(
  rounded="xl"
  :max-width="fullWidth ? '100%' : 280"
  :class="{ 'ma-4': !hideTitle }"
)
  h3.text-h6.redesignBlack--text.font-weight-bold.text-none.text-center.py-3(
    v-if="!hideTitle"
  ) Вход в систему
  p.ma-2.ev-caption.text-center Можно использовать логин и пароль ПФДО
  .mb-2.pa-4
    v-tabs-items(v-model="currentTabIndex")
      v-tab-item
        credentials-tab(@auth="applyJwt")
        //- telegram-sign-in-button(@click="setTabIndex(constants.SIGN_IN_TAB_TYPE.telegram)").mt-3
      v-tab-item
        telegram-tab(
          @tab:back="setTabIndex(constants.SIGN_IN_TAB_TYPE.credentials)"
          @auth="applyJwt"
        )
    fast-register-form(
      slim
    )
</template>

<script>
import { mapActions } from 'vuex';
import CredentialsTab from './components/CredentialsTab.vue';
import TelegramSignInButton from './components/telegram/TelegramSignInButton.vue';
import TelegramTab from './components/telegram/TelegramTab.vue';
import { apiService } from '@/services/APIService';
import JWTService from '@/services/JWTService';
import { SYSTEMS_API } from './constants';
import FastRegisterForm from '@/modules/Auth/views/Register/forms/FastRegisterForm.vue';

const SIGN_IN_TAB_TYPE = {
  credentials: 0,
  telegram: 1,
};

export default {
  name: 'LoginForm',
  components: {
    CredentialsTab,
    TelegramSignInButton,
    TelegramTab,
    FastRegisterForm,
  },
  props: {
    hideTitle: {
      type: Boolean,
      default: false,
    },
    noRedirect: {
      type: Boolean,
      default: false,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentTabIndex: SIGN_IN_TAB_TYPE.credentials,
    };
  },
  computed: {
    constants() {
      return {
        SIGN_IN_TAB_TYPE,
      };
    },
  },
  created() {},
  methods: {
    ...mapActions({
      init: 'auth/init',
    }),
    setTabIndex(index) {
      this.currentTabIndex = index;
    },
    async applyJwt(response) {
      const { member, certificate, organization, expert } = this.$conf.ROLES;
      const REDIRECT_BY_ROLES = {
        [member]: { name: 'redesign-main' },
        [certificate]: { name: 'redesign-main' },
        [organization]: { name: 'main' },
        [expert]: { name: 'main' },
      };

      JWTService.setToken(response.data.data.access_token);
      JWTService.setRefreshToken(response.data.data.refresh_token);

      await this.init();

      const userData = this.$user.data;
      const userSocials = userData.social?.map(({ type }) => type);

      if (userSocials.includes(userData.active_system)) {
        const authResponse = await this.$api.user
          .transferUser({
            type: userData.active_system,
          })
          .catch(() => null);
        if (authResponse?.data?.data) {
          apiService.changeApiUrl(SYSTEMS_API[userData.active_system]);
          JWTService.setToken(authResponse.data.data.access_token);
          JWTService.setRefreshToken(authResponse.data.data.refresh_token);
        }
      }
      if (!this.noRedirect) {
        if (this.$route.query.redirect) {
          this.$router.push(this.$route.query.redirect);
        } else {
          const [role] = this.$user.roles;
          let redirectPath = REDIRECT_BY_ROLES[role.name] || '/';

          if ([member, certificate].includes(role.name)) {
            const params = {
              'search[status]': 1,
              'search[progress]': 2,
              'search[request_status]': 3,
            };
            const { response: userEventsResponse } = await this.$rApi.events.searchEvents({ params });
            if (userEventsResponse?.data?.data?.length) {
              redirectPath = { name: 'redesign-home' };
            }
          }
          this.$router.push(redirectPath);
        }
      }

      this.$drawer.subdrawerHide();
      this.$emit('logged');
    },
  },
};
</script>
